<template>
    <div class="col-md-8 offset-lg-1">
        <div v-html="content">
            
        </div>
        <div class="row no-gutters" style="background: #F7F7F7 0% 0% no-repeat padding-box;">
            <div class="col-md-6 padding-0">
                <div class="embed-responsive"  style="height: 100%; width: 100%">
                    <iframe
                        frameborder="0"
                        class="embed-responsive-item"
                        allowfullscreen
                        :src="videoUrl"
                    >
                    </iframe>
                </div>
                <div class="overlay d-flex justify-content-center align-items-center"  v-if="showPlayBtn">
                    <button
                        class="btn btn-secondary btn-sm btn-caret"
                        style="background: rgba(0, 0, 0, 0.0); color: white; border: none"
                        @click="playVideo"
                    >
                        Bekijk Video
                    </button>
                </div>
            </div>
            <div class="col-md-6 p-4">
                <div>
                    <h4 class="text-uppercase">Video Xylella</h4>
                    <p>
                        {{videoText}}
                    </p>
                </div>
            </div>
        </div>
        <xylella-vragenlijst-index class="my-5" :locations="locations"/>
        <!--<div style="margin-top: 100px;">
            <xylella-infected-loc></xylella-infected-loc>
        </div>-->
    </div>
</template>

<script>
import XylellaInfectedLoc from './XylellaInfectedLoc.vue';
import XylellaVragenlijstIndex from './XylellaVragenlijstIndex.vue';

export default {
  components: { XylellaInfectedLoc,XylellaVragenlijstIndex },
    props: {
        locations: Array,
        content: String,
        videoUrl: String,
        videoText: String,
    },
  data() {
    return {
      showPlayBtn: true
    }
  },
  methods: {
    playVideo(){
      this.togglePlayBtn();
    },
    togglePlayBtn(){
      this.showPlayBtn = !this.showPlayBtn;
    }
  },

}
</script>

<style scoped>
.padding-0{
    padding-right:0;
    padding-left:0;
}
.overlay{
    position:absolute;
    top:0;
    left:0;
    width: 100%;
    height: 100%;
    z-index:1;
    -webkit-backdrop-filter: blur(3px);
    backdrop-filter: blur(3px);
    background-color: rgba(0, 0, 0, 0.2);
}
.overlay-text {
    color: white;
    font-size: 20px;
}
.video {
    width:100%; 
    height:100%
}
</style>